import { z } from 'zod';

import { EmailSchema, UniqueArraySchema } from '@vestigas/utils';
import { i18n } from '~/utils';

import {
  AI_MODEL_CHOICE_OPTIONS,
  AI_MODEL_TYPE_OPTIONS,
  ENVIRONMENT_OPTIONS,
  PROCESS_BULK_OPTIONS,
} from './constants';

export const zodAiModelEntrySchema = z.object({
  // Empty/missing surfaces the centrally-translated "required" message via the global Zod error map.
  modelId: z.string().trim().min(1),
  modelType: z.enum(AI_MODEL_TYPE_OPTIONS),
});

// fallow-ignore-next-line unused-export
export const zodCompanyAiSettingsCustomSettingsSchema = z.object({
  diPlusAiFoundryFieldsToReplace: z.array(z.string()).nullable().prefault([]),
  languageEncoding: z
    .union([
      z
        .string()
        .trim()
        .length(2)
        .transform((value) => value?.toUpperCase()),
      z.literal(''),
    ])
    .nullable(),
  modelChoice: z
    .union([z.enum(AI_MODEL_CHOICE_OPTIONS), z.literal('')])
    .prefault('di')
    .nullable(),
  processBulk: z.enum(PROCESS_BULK_OPTIONS).prefault('false').nullable(),
  requireIssuer: z.boolean().prefault(false),
});

export const zodUpdateCompanyAiSettingsSchema = z.object({
  aiModel: z.array(zodAiModelEntrySchema).min(
    1,
    i18n.t(($) => $.companies.aiSettings.aiModel.required, { ns: 'clients' }),
  ),
  customSettings: zodCompanyAiSettingsCustomSettingsSchema.nullable(),
  environment: z.enum(ENVIRONMENT_OPTIONS).nullable().prefault('dev'),
  senderAddresses: UniqueArraySchema(EmailSchema).nullable(),
  senderDomain: z
    .union([z.string().trim().regex(z.regexes.domain), z.literal('')])
    .nullable(),
});

export const zodUpdateCompanyAiSettingsEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('company'),
  z.uuid(),
  z.literal('default_ai_model_settings'),
]);
